export var RequestStatus;
(function (RequestStatus) {
    RequestStatus["NEW"] = "NEW";
    RequestStatus["DOCS_REQUIRED"] = "DOCS_REQUIRED";
    RequestStatus["NOTARY_REQUIRED"] = "NOTARY_REQUIRED";
    RequestStatus["READY_TO_SUBMIT"] = "READY_TO_SUBMIT";
    RequestStatus["SUBMITTED"] = "SUBMITTED";
    RequestStatus["APPOINTMENT_REQUIRED"] = "APPOINTMENT_REQUIRED";
    RequestStatus["CANCELLED"] = "CANCELLED";
    RequestStatus["APPROVED"] = "APPROVED";
    RequestStatus["REJECTED"] = "REJECTED";
    RequestStatus["DELIVERED"] = "DELIVERED";
})(RequestStatus || (RequestStatus = {}));
export const requestStatusLabels = {
    [RequestStatus.NEW]: "New",
    [RequestStatus.DOCS_REQUIRED]: "Documents Required",
    [RequestStatus.NOTARY_REQUIRED]: "Notary Required",
    [RequestStatus.READY_TO_SUBMIT]: "Ready To Submit",
    [RequestStatus.SUBMITTED]: "Submitted",
    [RequestStatus.APPOINTMENT_REQUIRED]: "Appointment Required",
    [RequestStatus.CANCELLED]: "Cancelled",
    [RequestStatus.APPROVED]: "Approved",
    [RequestStatus.REJECTED]: "Rejected",
    [RequestStatus.DELIVERED]: "Delivered",
};
